import * as types from './types';

const sortMessages = (arr) => {
  return arr.slice().sort((a, b) => a.createdAt - b.createdAt);
};

function findExistingMessageIndex(target, message) {
  return target.findIndex(
    (m) =>
      (message.reqId && m.reqId && m.reqId === message.reqId) ||
      (m.messageId === message.messageId && message.messageId !== 0)
  );
}

export default {
  [types.RESET_MESSAGES](state, channelUrl) {
    console.log('DEBUG => [MUTATION] => RESET_MESSAGES channelUrl: ', channelUrl)
    state.messages[channelUrl] = { history: [], live: [] };
  },

  [types.RESET_CHAT_MESSAGES](state, channelUrl) {
    state.messages[channelUrl] = { history: [], live: [] };
  },

  // mutations.js (sendbird)
  [types.SET_CHAT_MESSAGES](state, { channelUrl, messages = [], mode = 'history' }) {
    // Ensure the per-channel container exists in the new shape
    const existing = state.messages[channelUrl] || { history: [], live: [] };

    if (mode === 'history') {
      existing.history = Array.isArray(messages) ? messages : [];
    } else if (mode === 'live') {
      existing.live = Array.isArray(messages) ? messages : [];
    } else {
      // default to history
      existing.history = Array.isArray(messages) ? messages : [];
    }

    state.messages = {
      ...state.messages,
      [channelUrl]: existing,
    };
    state.chatHistory = {
      ...(state.chatHistory || {}),
      [channelUrl]: existing.history,
    };
    console.log('DEBUG => [MUTATION] => SET_CHAT_MESSAGES channelUrl: ', channelUrl, ', mode: ', mode, ', state.messages[channelUrl]: ', state.messages[channelUrl], ', state.chatHistory[channelUrl]: ', state.chatHistory[channelUrl]);
  },
  [types.SET_RECENT_MESSAGES_REPLACE](state, { channelUrl, messages }) {
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }

    state.messages[channelUrl].live = (messages || [])
      .slice()
      .sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
  },

  [types.ADD_MESSAGE](state, { channelUrl, message, userProfile, hasmore }) {
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }

    const target = state.messages[channelUrl].live;

    const existingIdx = findExistingMessageIndex(target, message);

    if (existingIdx !== -1) {
      target.splice(existingIdx, 1, message);
    } else {
      if (hasmore) {
        target.unshift(message);
      } else {
        target.push(message);
      }
    }

    state.messages[channelUrl].live = sortMessages(target);
  },

  [types.ADD_HISTORY_MESSAGES](state, { channelUrl, messages }) {
    console.log('DEBUG => [MUTATION] => ADD_HISTORY_MESSAGES channelUrl: ', channelUrl, ', messages: ', messages)
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }
    state.messages[channelUrl].history = sortMessages(messages);
  },

  [types.ADD_ATTACHMENT_MESSAGE](state, { channelUrl, message, userProfile, hasmore }) {
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }

    const target = state.messages[channelUrl].live;

    const existingIdx = findExistingMessageIndex(target, message);

    if (existingIdx !== -1) {
      target.splice(existingIdx, 1, message);
    } else {
      if (hasmore) {
        target.unshift(message);
      } else {
        target.push(message);
      }
    }

    state.messages[channelUrl].live = sortMessages(target);
  },

  [types.SET_TYPING](state, channel) {
    state.isTyping = !!channel;
  },

  [types.SET_MESSAGECOUNTS](state, counts) {
    state.directMessageCount = counts || 0;
    state.messageCounts = counts || 0;
  },

  [types.RESET_CHANNELS](state) {
    state.channels = [];
    state.token = '';
  },

  [types.SET_CHANNELS](state, data) {
    // Reset first, then repopulate
    state.channels = [];
    state.token = '';

    const list = Array.isArray(data?.channels) ? data.channels : [];

    for (const ch of list) {
      // guard each item; only keep those with unread > 0
      const unread = Number(ch?.unread_message_count ?? 0);
      if (unread > 0) state.channels.push(ch);
    }

    state.token = data?.next ?? '';
  },
  [types.SET_CHAT_HISTORY](state, { channelUrl, messages }) {
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }
    state.messages[channelUrl].history = sortMessages(messages);
    state.messages[channelUrl].live = []; // Reset live when loading history
  },

  [types.ADD_LIVE_MESSAGE](state, { channelUrl, message }) {
    console.log('DEBUG => [MUTATION] => ADD_LIVE_MESSAGE channelUrl: ', channelUrl, ', message: ', message)
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }
    const exists = state.messages[channelUrl].live.find(m => m.messageId === message.messageId);
    if (!exists) {
      state.messages[channelUrl].live.push(message);
    }
  },

  [types.RESET_CHAT](state, channelUrl) {
    state.messages[channelUrl] = { history: [], live: [] };
  },

  [types.SET_RECENT_MESSAGES](state, { channelUrl, messages }) {
    if (!state.messages[channelUrl]) {
      state.messages[channelUrl] = { history: [], live: [] };
    }

    const existing = state.messages[channelUrl].live || [];
    const byKey = new Map();

    const put = (m) => {
      if (!m) return;
      const key = m.messageId || m.reqId;
      if (!key) return;
      byKey.set(key, m); // latest wins
    };

    // keep current live
    for (const m of existing) put(m);
    // merge in fresh server window
    for (const m of messages) put(m);

    state.messages[channelUrl].live = Array.from(byKey.values())
      .sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
  }
};
